import { render } from "./limits.vue?vue&type=template&id=a5e24e3c&scoped=true"
import script from "./limits.vue?vue&type=script&lang=js"
export * from "./limits.vue?vue&type=script&lang=js"

import "./limits.vue?vue&type=style&index=0&id=a5e24e3c&scoped=true&lang=css"

import exportComponent from "/Users/cole/.codex/worktrees/jwt-cookie-expiry/tcd-cube_opr/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a5e24e3c"]])

export default __exports__